/* eslint-disable dot-notation */
import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter, Route } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import VisitorAnalytics from './components/Hocs/VisitorAnalytics';
import App from './App';
import { unregister } from './registerServiceWorker';
import './index.css';

ReactDOM.render(
  <CookiesProvider>
    <Provider store={store}>
      <BrowserRouter basename={process.env['ROUTE_BASENAME']}>
        {process.env['ENV_TYPE'] === 'production' ? (
          <Route component={VisitorAnalytics(App)} />
        ) : (
          <App />
        )}
      </BrowserRouter>
    </Provider>
  </CookiesProvider>,
  document.getElementById('root')
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js